<template>
  <v-container class="pb-0 pl-0 pr-0">
    <v-snackbar top v-model="message.show" multi-line :color="message.mode">
      {{ message.text }}
      <v-btn text @click="message.show = false">Close</v-btn>
    </v-snackbar>
    <v-navigation-drawer
      disable-resize-watcher
      v-model="drawerRight"
      app
      clipped
      right
      width="350"
      height="100%"
      class="pa-6"
    >
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <!-- v-show="!drawerLoading" -->
            <v-list-item-title class="title pb-3">
              {{
              editingData.id
              }}
            </v-list-item-title>
            <v-list-item-content>
              <span class="subtitle-1">Name</span>
            </v-list-item-content>
            <v-row no-gutters>
              <v-col md="12" class="ma-0">
                <v-text-field label="Company Name" v-model="editingData.nameCompany" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-list-item-content>
              <span class="subtitle-1">Location</span>
            </v-list-item-content>
            <v-row v-if="mapCenter.lat">
              <v-col md="12">
                <GmapMap
                  class="mb-3"
                  :center="mapCenter"
                  :zoom="16"
                  map-type-id="terrain"
                  style="height: 190px;"
                >
                  <GmapMarker :position="mapCenter" />
                </GmapMap>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col md="6" class="ma-0">
                <v-text-field label="Latitude" v-model="editingData.lat" outlined></v-text-field>
              </v-col>
              <v-col md="6" class="ma-0">
                <v-text-field label="Longitude" v-model="editingData.lng" outlined></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col md="12" class="ma-0">
                <v-textarea label="Address" v-model="editingData.address" outlined></v-textarea>
              </v-col>
            </v-row>
            <v-list-item-content>
              <span class="subtitle-1">Settings</span>
            </v-list-item-content>
            <v-row no-gutters>
              <v-col md="6" class="ma-0">
                <v-text-field
                  label="Cutoff Date"
                  v-model="editingData.cutoffDate"
                  outlined
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col md="6"></v-col>
              <v-col md="6" class="ma-0">
                <v-switch
                  label="Status"
                  class="my-0 py-0 mt-5 ml-2"
                  v-model="editingData.status"
                  @change="changeStatus()"
                ></v-switch>
              </v-col>
              <v-col md="6" class="ma-0">
                <v-select
                  :items="clientType"
                  label="Type"
                  v-model="editingData.type"
                  item-text="text"
                  item-value="value"
                  required
                ></v-select>
              </v-col>
              <v-col md="12" class="ma-0">
                <v-text-field label="Name PIC" v-model="editingData.name_pic" outlined></v-text-field>
              </v-col>
              <v-col md="12" class="ma-0">
                <v-text-field label="Email PIC" v-model="editingData.email_pic" outlined></v-text-field>
              </v-col>
              <v-col md="12" class="ma-0">
                <v-text-field label="Contact PIC" v-model="editingData.contact_pic" outlined></v-text-field>
              </v-col>
              <v-col md="12" class="ma-0">
                <v-text-field label="End Date" v-model="editingData.end_date" outlined type="date"></v-text-field>
              </v-col>
              <v-col md="12" class="ma-0">
                <v-textarea label="Reason End" v-model="editingData.reason_end" outlined></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <v-btn block text @click="closeDrawer">Cancel</v-btn>
              </v-col>
              <v-col md="6">
                <v-btn
                  block
                  depressed
                  color="primary"
                  :loading="updateLoading"
                  @click="updateCompanyData(editingData)"
                >Save</v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-container fluid v-show="drawerLoading">
        <v-row align="center" justify="center" style="height: 500px;">
          <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-container fill-height fluid v-show="loading">
      <v-row align="center" justify="center" style="height: 80vh;">
        <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
      </v-row>
    </v-container>
    <v-container class="pb-0 pl-0 pr-0">
      <v-row class="px-4">
        <v-dialog v-model="dialog" persistent max-width="600">
          <template v-slot:activator="{ }">
            <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
            <!-- <v-btn color="primary" v-on="on" class="my-6">
              <v-icon left dark>mdi-plus</v-icon>
              Add Company
            </v-btn>-->
            <v-row>
              <v-col md="6">
                <v-text-field
                  hide-details
                  label="Find Company"
                  prepend-inner-icon="mdi-magnify"
                  single-line
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <v-card class="pa-3">
            <v-card-title class="headline">Add Company</v-card-title>
            <v-card-text>
              <v-list-item-content>
                <span class="subtitle-1">Name</span>
              </v-list-item-content>
              <v-row>
                <v-col md="6" class="ma-0">
                  <v-text-field label="Company ID" v-model="creatingData.id" outlined></v-text-field>
                </v-col>
                <v-col md="6" class="ma-0">
                  <v-text-field label="Company Name" v-model="creatingData.name_company" outlined></v-text-field>
                </v-col>
              </v-row>
              <v-list-item-content>
                <span class="subtitle-1">Location</span>
              </v-list-item-content>
              <v-row>
                <v-col md="6" class="ma-0">
                  <v-text-field label="Latitude" v-model="creatingData.lat_company" outlined></v-text-field>
                </v-col>
                <v-col md="6" class="ma-0">
                  <v-text-field label="Longitude" v-model="creatingData.lng_company" outlined></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" class="ma-0">
                  <v-textarea label="Address" v-model="creatingData.address_company" outlined></v-textarea>
                </v-col>
              </v-row>
              <v-list-item-content>
                <span class="subtitle-1">Settings</span>
              </v-list-item-content>
              <v-row>
                <v-col md="6" class="ma-0">
                  <v-text-field
                    label="Cutoff Date"
                    v-model="creatingData.cutoff_date"
                    outlined
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
              <v-btn
                color="primary"
                :loading="createLoading"
                @click="createCompanyData(creatingData)"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Import Data -->
        <v-dialog v-model="alert" persistent max-width="600">
          <v-card class>
            <v-progress-linear :color="alert_mode" height="10" value="100"></v-progress-linear>
            <v-card-title class="headline">
              Log Result
              <v-btn color class="ml-auto center" @click="showNotif">
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-list shaped>
            <v-list-item-content
              v-for="item in alert_text"
              :key="item.title"
              class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
            >
              <v-card-text>{{ item }}</v-card-text>
              <v-divider horizontal class="mt-1 mb-3"></v-divider>
            </v-list-item-content>
          </v-list>
        </v-dialog>

        <v-dialog v-model="notif.show" persistent max-width="600">
          <v-card class>
            <v-progress-linear :color="notif.mode" height="10" value="100"></v-progress-linear>
            <v-card-title class="headline">
              Next Step
              <v-btn color class="ml-auto center" @click="notif.show = false">
                <v-icon dark>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          </v-card>
          <v-list shaped>
            <v-list-item-content
              v-for="item in notif.text"
              :key="item"
              class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
            >
              <v-card-text>
                <b class="red--text">{{ item }}</b>
              </v-card-text>
              <v-divider horizontal class="mt-1 mb-3"></v-divider>
            </v-list-item-content>
          </v-list>
        </v-dialog>

        <v-dialog v-model="dialogHoliday" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" class="my-6 ml-auto mr-1">Import Holiday</v-btn>
          </template>
          <v-card class="pa-3">
            <v-card-title class="pa-0">Import Holiday</v-card-title>
            <!-- <v-btn class="pull-right" icon @click="dialogHoliday = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>-->
            <v-row>
              <v-col md="6">
                <v-autocomplete
                  v-model="holiday.companyId"
                  :items="companies"
                  color="white"
                  hide-no-data
                  item-text="nameCompany"
                  item-value="id"
                  placeholder="Select Company"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col md="6">
                <v-text-field label="Year" v-model="holiday.year" outlined type="number"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6">
                <v-btn text @click="dialogHoliday = false">Cancel</v-btn>
              </v-col>
              <v-col md="6" class>
                <v-btn
                  class="float-right mr-2"
                  color="primary"
                  :loading="holiday.loading"
                  @click="saveHoliday(holiday)"
                >Save</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>

        <v-dialog v-model="impor" persistent max-width="600">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on" class="my-6 ml-auto">
              <v-icon left dark>mdi-import</v-icon>Import Data
            </v-btn>
          </template>

          <v-card class="pa-3">
            <v-card-title class="headline">
              Import Data
              <div v-show="!imporLoading" class="ml-auto">
                <v-btn depressed small @click="impor = false">
                  <v-icon flat>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-card-title>
            <v-card-text>
              <v-list-item-content>
                <span class="subtitle-1">Sheet ID</span>
              </v-list-item-content>
              <v-row class="m-0">
                <v-col md="12" class="m-0">
                  <v-text-field
                    :autofocus="blue"
                    :hide-details="blue"
                    label="Sheet ID"
                    v-model="imporData.sheetId"
                    outlined
                    :hint="'Share sheetsaccess@appsensi-dev.iam.gserviceaccount.com for access permission'"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-list-item-content>
                <span class="subtitle-1">Import</span>
              </v-list-item-content>
              <v-row class="m-0">
                <v-col md="12" class="m-0 p-0">
                  <!-- <v-divider horizontal class="mt-1 mb-3"></v-divider> -->
                  <v-list-item-content class="m-0 p-0 pt-0 pb-0 mt-0 mb-0">
                    <v-checkbox
                      class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                      :value="imporData.all"
                      :key="'Select All'"
                      :label="'Select All'"
                      v-model="imporData.all"
                      @change="selectAllImporData($event)"
                    ></v-checkbox>
                  </v-list-item-content>

                  <v-list class="m-0 p-0 pt-0 pb-0 mt-0 mb-0">
                    <!-- import Checkbox -->
                    <v-list-item-content
                      v-for="(item, index) in codeInsert"
                      :key="item.title"
                      class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                    >
                      <v-checkbox
                        class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                        :value="item.value"
                        :key="item.title"
                        :label="item.title"
                        v-model="imporData.code[index]"
                      ></v-checkbox>
                    </v-list-item-content>
                    <v-divider horizontal class="mt-1 mb-3"></v-divider>

                    <!-- update Checkbox -->
                    <v-list-item-content>
                      <span class="subtitle-1 text-muted">Update</span>
                    </v-list-item-content>
                    <v-list-item-content
                      v-for="item in codeUpdate"
                      :key="item.title"
                      class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                    >
                      <v-checkbox
                        class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                        :value="item.value"
                        :key="item.title"
                        :label="item.title"
                        v-model="imporData.code[item.value]"
                      ></v-checkbox>
                    </v-list-item-content>
                    <v-divider horizontal class="mt-1 mb-3"></v-divider>

                    <!-- export Checkbox -->
                    <v-list-item-content>
                      <span class="subtitle-1 text-muted">Export</span>
                    </v-list-item-content>
                    <v-list-item-content
                      v-for="(item, i) in codeExport"
                      :key="item.title"
                      class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                    >
                      <v-checkbox
                        class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
                        :value="item.value"
                        :key="item.title"
                        :label="item.title"
                        v-model="imporData.code[i + 7]"
                      ></v-checkbox>
                    </v-list-item-content>
                  </v-list>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="!imporLoading">
                <v-btn color="primary" text @click="impor = false">Cancel</v-btn>
                <v-btn
                  depressed
                  color="primary"
                  :loading="updateLoading"
                  @click="submitImporData(imporData)"
                >Submit</v-btn>
              </div>

              <div v-show="imporLoading">
                <v-progress-circular :size="40" color="primary" indeterminate></v-progress-circular>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="companies"
        :search="search"
        sort-by="nameCompany"
        class="elevation-1"
        :no-data-text="$t('no_data')"
        :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
      >
       <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
        <template v-slot:item.createdAt="{ item }">{{ formatDate(item.createdAt) }}</template>
        <template v-slot:item.status="{ item }">{{ item.status ? "Active" : "Inactive" }}</template>
        <template v-slot:item.location="{ item }">{{ item.lat_company }}, {{ item.lng_company }}</template>
        <template v-slot:item.action="{ item }">
          <v-btn icon @click="showDrawer(item)" color="primary">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import moment from 'moment';
export default {
  name: "CompanyNonActiveClient",
  data() {
    return {
      dialogHoliday: false,
      holiday: {
        year: null,
        companyId: null,
        loading: false,
      },
      search: '',
      clientType: [
        { text: 'Stop Onboarded', value: 'Stop Onboarded' },
        { text: 'End Trial', value: 'End Trial' },
      ],
      headers: [
        // { text: "ID", value: "id"},
        { text: "Name", value: "nameCompany" },
        { text: "Join Date", value: "createdAt" },
        { text: "Cutoff Date", value: "cutoffDate" },
        { text: "Active User", value: "userCount" },

        { text: "Type", value: "type" },
        { text: "Action", value: "action" },
      ],
      notif: {
        show: false,
        mode: 'primary',
        text: [
          'Update data Slug.',
          'Add Config on Menu Company Config.',
        ],
      },
      message: {
        show: false,
        mode: '',
        text: ''
      },
      baseUrl: this.$store.state.baseUrl,
      blue: true,
      loading: false,
      dialog: false,
      impor: false,
      drawerRight: false,
      drawerLoading: false,
      updateLoading: false,
      createLoading: false,
      imporLoading: false,
      companies: [],
      editingData: {},
      creatingData: {},
      imporData: { code: [], all: false, insertCode: [] },
      codeInsert: [
        { title: 'Company Data', value: 1 },
        { title: 'Group Data', value: 2 },
        { title: 'Schedule Group Data', value: 3 },
        { title: 'Zone Master Data', value: 4 },
        { title: 'Zone Transaction Data', value: 5 },
        { title: 'User Data', value: 6 },
        { title: 'Schedule User Data', value: 7 },
      ],
      codeUpdate: [
        { title: "Update Slug Group", value: 11 },
      ],
      codeExport: [
        { title: "Group List", value: 8 },
        { title: "Zone Master List", value: 9 },
        { title: "Users List", value: 10 },
      ],
      alert: false,
      alert_text: "",
      alert_mode: "",
    }
  },
  methods: {
    async saveHoliday({ companyId, year }) {
      this.holiday.loading = true
      const body = { companyId, year }
      const result = await this.$store.dispatch('saveMasterHolidayCopy', body)
      this.holiday.loading = false
      if (result) {
        this.showMessage('success', 'Success Insert Data Holiday')
      }
    },
    changeStatus() {
      this.clientType = [
          { text: 'Trial', value: 'Trial' },
          { text: 'Onboarded', value: 'Onboarded' },
          { text: 'Internal', value: 'Internal' },
          { text: 'Stop Onboarded', value: 'Stop Onboarded' },
          { text: 'End Trial', value: 'End Trial' },
      ]
      // if (event) {
      //   this.clientType = [
      //     { text: 'Trial', value: 'Trial' },
      //     { text: 'Onboarded', value: 'Onboarded' },
      //     { text: 'Internal', value: 'Internal' },
      //   ]
      // } else {
      //   this.clientType = [
      //     { text: 'Stop Onboarded', value: 'Stop Onboarded' },
      //     { text: 'End Trial', value: 'End Trial' },
      //   ]
      // }
    },
    formatDate(date) {
      return moment(date).format('DD-MMM-YYYY')
    },
    showNotif() {
      this.alert = false
      if (this.alert_mode != 'error') {
        this.notif.show = true
      }
    },
    showAlert(mode, text) {
      this.alert_mode = mode
      this.alert_text = text
      this.alert = true
    },
    showMessage(mode, text) {
      this.message.mode = mode
      this.message.text = text
      this.message.show = true
    },
    async getCompanies() {
      this.loading = true;
      const result = await this.$store.dispatch('getCompanyWithUserCount')
      this.companies = []
      result.map(item => {
        if (!item.status) {
          this.companies.push(item)
        }
      })
      this.loading = false;
    },
    showDrawer(item) {
      this.drawerRight = true;
      this.editingData = Object.assign({}, item);
      this.changeStatus()
    },
    closeDrawer() {
      this.drawerRight = false;
    },
    validReasonEnd(company) {
      if (!company.is_active) {
        if (company.reason_end) {
          if (company.reason_end.length > 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
      return true
    },
    async updateCompanyData(company) {
      if (!this.validReasonEnd(company)) return this.showMessage('warning', 'Please fill in Reason End')
      this.updateLoading = true;
      const body = {
        id_company: company.id,
        name_company: company.nameCompany,
        lat_company: company.lat,
        lng_company: company.lng,
        address_company: company.address,
        cutoff_date: company.cutoffDate,
        is_active: company.status,
        type: company.type,
        name_pic: company.name_pic,
        email_pic: company.email_pic,
        contact_pic: company.contact_pic,
        end_date: company.end_date,
        reason_end: company.reason_end,
      }
      const result = await this.$store.dispatch('editCompanyData', body)
      this.updateLoading = false;
      if (result) {
        this.drawerRight = false;
        this.getCompanies();
      }
    },
    async createCompanyData(company) {
      this.createLoading = true;
      const body = {
        id_company: company.id,
        name_company: company.name_company,
        lat_company: company.lat_company,
        lng_company: company.lng_company,
        address_company: company.address_company,
        cutoff_date: company.cutoff_date
      }
      const result = await this.$store.dispatch('saveCompanyData', body)
      this.createLoading = false;
      if (result) {
        this.creatingData = {};
        this.dialog = false;
        this.getCompanies();
      }
    },
    selectAllImporData(data) {
      if (data == true) {
        this.imporData.code = []
        this.imporData.all = true
        this.codeInsert.map(item => {
          this.imporData.code.push(item.value)
        })
      } else {
        this.imporData.all = false
        this.imporData.code = []
      }
    },
    async submitImporData(data) {
      this.imporLoading = true
      if (data.code) {
        data.insertCode = []
        data.code.map(item => {
          if (item) {
            data.insertCode.push(item)
          }
        })
      }
      const body = {
        sheetId: data.sheetId,
        insertCode: data.insertCode,
      }
      const result = await this.$store.dispatch('saveClientData', body)
      this.imporLoading = false
      if (result) {
        this.imporData = { code: [], all: false, insertCode: [] }
        this.impor = false
        this.showAlert("success", 'Data Imported');
        this.getCompanies()
      }
    }
  },
  computed: {
    mapCenter() {
      const edit = this.editingData
      const data = {
        lat: edit ? edit.lat_company : null,
        lng: edit ? edit.lng_company : null,
      }
      return data
    }
  },
  created() {
    this.getCompanies();
  },
}
</script>